import { useMemo, useState } from 'react';
import { navItems } from '@/mocks/heiliao';
import { useScrollSpy } from '@/hooks/useScrollSpy';
import { useReveal } from '@/hooks/useReveal';
import SiteHeader from '@/pages/home/components/SiteHeader';
import HeroSection from '@/pages/home/components/HeroSection';
import TickerBar from '@/pages/home/components/TickerBar';
import CategorySection from '@/pages/home/components/CategorySection';
import RankingSection from '@/pages/home/components/RankingSection';
import DossierSection from '@/pages/home/components/DossierSection';
import TagSection from '@/pages/home/components/TagSection';
import FaqSection from '@/pages/home/components/FaqSection';
import AboutSection from '@/pages/home/components/AboutSection';
import SubscribeSection from '@/pages/home/components/SubscribeSection';
import SiteFooter from '@/pages/home/components/SiteFooter';
import BackToTop from '@/pages/home/components/BackToTop';

export default function Home() {
  const sectionIds = useMemo(() => navItems.map((item) => item.id), []);
  const activeId = useScrollSpy(sectionIds);
  const [activeCategory, setActiveCategory] = useState('全部');

  useReveal();

  const handleCategorySelect = (name: string) => {
    setActiveCategory(name);
    const el = document.getElementById('ranking');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader activeId={activeId} />
      <main>
        <HeroSection />
        <TickerBar />
        <CategorySection onSelect={handleCategorySelect} />
        <RankingSection activeCategory={activeCategory} onChangeCategory={setActiveCategory} />
        <DossierSection />
        <TagSection />
        <FaqSection />
        <AboutSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}